//
// AxisIncludeRangeEntry.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "../core/styles/attributesMap/RangeBound";

var AxisIncludeRangeEntry = createModule("gtl::AxisIncludeRangeEntry", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        minValue: 1,
        maxValue: 1,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_o: [4,1],
        _create_oo: [4,1,1],
    },
    ,
    ["_create"]
]);
export default AxisIncludeRangeEntry;
